import { defineComponent as _defineComponent } from 'vue'
import ImageUploader from '@/components/ImageUploader.vue';
import { ImageV1 } from '@ilteducation/content-registry-types';
import { ref, watch } from 'vue';
import customProvider from '@/data-provider/customProvider';


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: ImageV1;
}



const hasConnectedKeyword = ref(false);

watch(
  () => props.id,
  (id) => {
    customProvider()
      .getList('keywords', { filter: { imageId: id }, pagination: { limit: 1 }, sort: [] })
      .then((res) => {
        hasConnectedKeyword.value = !!res.data && res.data.length > 0;
      });
  },
  { immediate: true },
);

return { __sfc: true,props, hasConnectedKeyword, ImageUploader }
}

})